// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I3U1","input":"styles_input__2E0UJ"};